import { TEXT_COLOR } from "@/bit/components/components.text";

export const NUM_MONTH = 18;

export const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const SHORT_MONTHS = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC",
];

export const DROP_DOWN_MOTHS_PERIODS = [
  { label: "Últimos 18 meses", value: 18, selected: true },
  { label: "Últimos 12 meses", value: 12, selected: false },
  { label: "Últimos 6 meses", value: 6, selected: false },
  { label: "Últimos 3 meses", value: 3, selected: false },
];

export const EMISSION = "Emisión";
export const DOWNLOAD_PDF = "PDF";
export const VIEW_DETAIL = "Ver detalle";
export const VIEW_CLAIM = "Ver reclamación";
export const PAID_DEB = "Pagar deuda";
export const ACTIVATE_ECO_BILL = "Activar factura sin papel";
export const LINK_ECO_BILL =
  "https://www.movistar.es/cliente/areaprivada/#/facturas/facturaSinPapel";
export const GO_ALL_BILLS = "Ver histórico";
export const DOWNLOAD_BILL = "Descargar";
export const LINK_ALL_BILLS = "/area-cliente/facturas/listado-facturas";
export const SEND_EMAIL_BILL = "Enviar por EMAIL";

export const TITLE_ALL_BILLS = "Histórico de facturas";
export const SELECT_ALL_LABEL = "Seleccionar todo";

export const MODAL_FILTER_TITLE = "Filtrar por";
export const MODAL_FILTER_BILLS_ALL_BILLS = "Todas las facturas";
export const MODAL_FILTER_BUTTON = "Continuar";

export const billDetailsText = {
  billDuplicate: "Pedir duplicado postal",
  billNo: "Factura: ",
  billFullNumber: "Factura: ",
  download: "PDF",
  downloading: "Descargando...",
  downloadCompleteBill: "Descargar factura completa",
  downloadResumeBill: "Descargar factura resumen",
  downloadBill: "Descargar factura",
  interactiveBill: "Factura Interactiva",
  issueDate: "Emisión: ",
  billDate: "Fecha: ",
  total: "Importe: ",
  completeBill: "completa",
  resumeBill: "resumen",
  allconsumption: "Ver todos los consumos",
};

export const claimBillText = {
  statusOpen: "Abierto",
  statusOngoing: "En curso",
  statusResolution: "En resolución",
  statusEnded: "Finalizada",
  phaseAnnulled: "Anulada",
  statusAnnulled: "Anulado",
  statusCanceled: "Anulada",
};

export const TITLE_NOT_BILLS = "Todavía no tienes facturas";
export const NO_MOVEMENTS = "Todavía no tienes movimientos";
export const SUB_TITLE_NOT_BILLS =
  "Pronto podrás consultarlas y descargarla en esta sección";

export const TITLE_ECO_BILL_ACTIVE = "Tienes activada la factura sin papel";
export const TITLE_ECO_BILL_DESACTIVE = "Tienes desactivada la factura sin papel";

export const URL_BILLS_HOME = "/area-cliente/facturas/";

export const ECO_BILL_CONDITIONS = `Consultar <a href="https://www.movistar.es/atencion-cliente/condiciones-fsp" target="_blank">Términos y Condiciones</a> de la factura sin papel`

export const CHANGE_EMAIL_ECO_BILL = "Puedes cambiar tu email en"
export const CHANGE_EMAIL_ECO_BILL_LINK_LABEL = "Email de contacto"
export const CHANGE_MOBILE_ECO_BILL = "Puedes editar teléfono para SMS en"
export const CHANGE_MOBILE_ECO_BILL_LINK_LABEL = "Teléfono de contacto"

export const MODAL_DESACTIVATE_ECO_BILL = {
  title: "¿Seguro que quieres desactivarla?",
  bullets: [
    {
      icon: "documento-m",
      label: "Volverás a acumular papeles innecesarios."
    },
    {
      icon: "arrow-down-m",
      label: "Ya no podrás descargarte la factura con validez legal."
    }, 
    {
      icon: "email-m",
      label: "Dejarás de recibir avisos cuando tu factura esté lista."
    }
  ]
}
export const TITLE_DOWNLOAD_BILL = "Para ver el detalle de tu factura, descárgatela.";

export const CHANGE_BILL_ADDRESS_LINK = "/area-cliente/facturas/direccion-de-facturacion/cambiar-direccion"
export const CHANGE_BILL_ADDRESS_LINK_LABEL = "Cambiar dirección"
export const USE_OTHER_BILL_ADDRESS_LINK_LABEL = "Utilizar otra dirección"
export const SAVE_ADDRESS_BUTTON = "Guardar dirección"

export const CHANGE_ADDRESS_BUTTON = "Cambiar dirección";
export const CHANGE_ADDRESS_CANCEL_BUTTON = "Cancelar";

export const ADDRESS_SEARCH_PLACEHOLDER = "Calle, número, ciudad";
export const MAP_MONTHS = {
  ENE: "01",
  FEB: "02",
  MAR: "03",
  ABR: "04",
  MAY: "05",
  JUN: "06",
  JUL: "07",
  AGO: "08",
  SEP: "09",
  OCT: "10",
  NOV: "11",
  DIC: "12",
};

export const CLAIM_DETAIL_LITERALS = {
  MODAL_TITLE: "Reclamación",
  START: "Apertura:",
  END: "Resolución:",
  RESULT: "Resolución:",
  PAYMENT: "Importe a tu favor:",
  BILL: "Factura:",
  BILLS: "Facturas:",
  BILL_CLAIM: "Factura reclamada:",
  BILLS_CLAIM: "Facturas reclamadas:", 
  NOTIFICATIONS: "Notificaciones recibidas",
  ALERT: "Esta factura está sin corregir. No te preocupes, en 10 días aproximadamente tras su emisión se realiza un ingreso con el importe a tu favor.",
  NEXT_BILL: "Tu siguiente factura está afectada"
}

export const ECO_BILL_ACTIVATE = [
  {
    id: "activate-1",
    color: TEXT_COLOR.GREY_600,
    text: "Hemos activado la factura sin papel.",
  },
  {
    id: "activate-2",
    color: TEXT_COLOR.GREY_600,
    text: "Te avisaremos por email cuando tengas una nueva factura disponible.",
  },
  {
    id: "activate-3",
    color: TEXT_COLOR.GREY_600,
    text: "Si tienes alguna factura en proceso de envío, el cambio se aplicará a partir de la siguiente factura.",
  },
];

export const ECO_BILL_DESACTIVATE = [
  {
    id: "activate-1",
    color: TEXT_COLOR.GREY_600,
    text: "Hemos desactivado la factura sin papel.",
  },
  {
    id: "activate-2",
    color: TEXT_COLOR.GREY_600,
    text: "Recuerda que puedes volver a activarla en cualquier momento.",
  },
  {
    id: "activate-3",
    color: TEXT_COLOR.GREY_600,
    text: "Si tienes alguna factura en proceso de envío, el cambio se aplicará a partir de la siguiente factura.",
  },
];
